import { c as _c } from "react/compiler-runtime";
export function BinaryTreeLogo(props) {
  const $ = _c(12);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path stroke="none" d="M0 0h24v24H0z" fill="none" />;
    t1 = <path d="M6 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />;
    t2 = <path d="M16 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />;
    t3 = <path d="M16 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />;
    t4 = <path d="M11 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />;
    t5 = <path d="M21 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />;
    t6 = <path d="M5.058 18.306l2.88 -4.606" />;
    t7 = <path d="M10.061 10.303l2.877 -4.604" />;
    t8 = <path d="M10.065 13.705l2.876 4.6" />;
    t9 = <path d="M15.063 5.7l2.881 4.61" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== props) {
    t10 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-binary-tree" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</svg>;
    $[10] = props;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
}